"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobx = require("mobx");
var _mobxReact = require("mobx-react");
var _dom = _interopRequireDefault(require("@myalbum/dom"));
var _store = _interopRequireDefault(require("./store"));
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var LazyList = (0, _mobxReact).observer(/*#__PURE__*/ function(_Component) {
    "use strict";
    _inherits(LazyList1, _Component);
    var _super = _createSuper(LazyList1);
    function LazyList1(props) {
        _classCallCheck(this, LazyList1);
        var _this;
        _this = _super.call(this, props);
        _this.ref = /*#__PURE__*/ _react.default.createRef();
        _this.measureRef = /*#__PURE__*/ _react.default.createRef();
        _this.store = new _store.default({
            getItemLayout: _this.props.getItemLayout,
            windowSize: _this.props.windowSize,
            onEndReached: _this.props.onEndReached,
            initialScrollIndex: _this.props.initialScrollIndex,
            onResize: _this.props.onResize,
            onScroll: _this.props.onScroll,
            direction: _this.props.direction,
            viewportOffset: _this.props.viewportOffset
        });
        _this.store.setItems(_this.props.data);
        if (_this.props.initalNumToRender !== undefined) _this.store.setVisibleItems(_this.props.data.slice(0, _this.props.initalNumToRender));
        return _this;
    }
    _createClass(LazyList1, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                for(var key in this.props)if (prevProps[key] !== this.props[key]) switch(key){
                    case "getItemLayout":
                        this.store.config.getItemLayout = this.props.getItemLayout;
                        break;
                    case "windowSize":
                        this.store.config.windowSize = this.props.windowSize;
                        break;
                    case "onEndReached":
                        this.store.config.onEndReached = this.props.onEndReached;
                        break;
                    case "onResize":
                        this.store.config.onResize = this.props.onResize;
                        break;
                    case "onScroll":
                        this.store.config.onScroll = this.props.onScroll;
                        break;
                    case "direction":
                        this.store.config.direction = this.props.direction;
                        break;
                    case "viewportOffset":
                        this.store.config.viewportOffset = this.props.viewportOffset;
                        break;
                    case "data":
                        this.store.setItems(this.props.data);
                        break;
                }
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                requestAnimationFrame(function() {
                    if (_this.ref.current) {
                        var dom = new _dom.default(_this.ref.current);
                        var scrollNode = dom.getScrollNode();
                        _this.store.mount(scrollNode, _this.ref.current, _this.measureRef.current);
                    }
                });
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.store.unmount();
            }
        },
        {
            key: "resetLayoutCache",
            value: function resetLayoutCache() {
                this.store.storeMaxSize(1, true, true);
                this.store.visibleItems.spaceAfter = 0;
                this.store.visibleItems.spaceBefore = 0;
                this.store.updateVisibleItems();
            }
        },
        {
            key: "updateVisibleItems",
            value: function updateVisibleItems() {
                this.store.updateVisibleItems();
            }
        },
        {
            key: "scrollTo",
            value: function scrollTo(pos, animate) {
                var _this = this;
                this.store._scrollToIndex = undefined;
                return new Promise(function(resolve) {
                    var _this1 = _this;
                    _this.store.scrollTo(pos, animate).then(function() {
                        _this1.store.updateVisibleItems();
                        resolve();
                    });
                });
            }
        },
        {
            key: "autoScrollToIndex",
            value: function autoScrollToIndex(index) {
                this.store._scrollToIndex = index;
            }
        },
        {
            key: "scrollToIndex",
            value: function scrollToIndex(index) {
                var animate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                this.store.scrollToIndex(index, animate);
            }
        },
        {
            key: "scrollIntoView",
            value: function scrollIntoView(index, config) {
                this.store.scrollIntoView(index, config);
            }
        },
        {
            key: "index",
            get: function get() {
                return this.store.currentIndex;
            }
        },
        {
            key: "indexesInViewport",
            get: function get() {
                return (0, _mobx).toJS(this.store.visibleItems.indexesInViewport);
            }
        },
        {
            key: "resize",
            value: function resize(force) {
                var index = this.index;
                this.store.scrollToIndex(index);
                this.store.resize(force);
                this.store.scrollTo(this.store.getItemPos(index));
                this.forceUpdate();
            }
        },
        {
            key: "dimensions",
            value: function dimensions() {
                return {
                    width: this.store.scroller.width,
                    height: this.store.scroller.height
                };
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var inView = this.store.visibleItems;
                var isVertical = this.props.direction === 'vertical';
                var style = _objectSpread({
                    display: 'flex',
                    flexDirection: isVertical ? 'column' : 'row',
                    alignItems: 'center',
                    position: 'relative',
                    userSelect: 'none',
                    flex: 1,
                    width: 'inherit'
                }, this.props.style);
                // Voorkom dat viewport geschaald wordt door de browser (bv safari ipad) als resizing slow is bij orientationChanges
                if (isVertical) style.maxWidth = '100vw';
                else style.maxHeight = '100vh';
                var measureStyle = {
                    position: 'absolute',
                    left: 0,
                    right: 0,
                    height: 0,
                    pointerEvents: 'none'
                };
                return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("div", {
                    ref: this.measureRef,
                    style: measureStyle
                }), /*#__PURE__*/ _react.default.createElement("div", {
                    ref: this.ref,
                    style: style,
                    className: "lazylist " + this.props.className,
                    onClick: this.props.onClick,
                    suppressHydrationWarning: true
                }, this.props.ListHeaderComponent !== undefined && this.props.ListHeaderComponent(this.dimensions()), inView.spaceBefore !== undefined && /*#__PURE__*/ _react.default.createElement("div", {
                    style: {
                        height: isVertical ? inView.spaceBefore : 0,
                        width: isVertical ? 0 : inView.spaceBefore
                    }
                }), inView.items.map(function(item, index) {
                    var size = inView.sizes[index];
                    return _this.props.renderItem(item, inView.index + index, size);
                }), inView.spaceAfter !== undefined && /*#__PURE__*/ _react.default.createElement("div", {
                    style: {
                        height: isVertical ? inView.spaceAfter : 0,
                        width: isVertical ? 0 : inView.spaceAfter
                    }
                }), this.store.items.length === 0 && this.props.ListEmptyComponent !== undefined && this.props.ListEmptyComponent(), this.props.ListFooterComponent !== undefined && this.props.ListFooterComponent(this.dimensions())));
            }
        }
    ]);
    return LazyList1;
}(_react.default.Component));
LazyList.defaultProps = {
    ListHeaderComponent: undefined,
    ListFooterComponent: undefined,
    ListEmptyComponent: undefined,
    onEndReached: function() {
        return Promise.resolve();
    },
    onClick: function() {},
    onScroll: function() {},
    initialScrollIndex: undefined,
    windowSize: 3,
    className: "",
    direction: "vertical",
    style: {},
    viewportOffset: {
        before: 0,
        after: 0
    }
};
var _default = LazyList;
exports.default = _default;
